import DefaultLayout from "@/views/Layout/DefaultLayout";
import i18n from "@/i18n.js";

const reportsMenu = {
    path: "/reports",
    component: DefaultLayout,
    meta: {
        title: i18n.t("title.reports")
    },
    children: [
        {
            path: "activities",
            name: "ReportsActivities",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VActivities"
                ),
            meta: {
                title: i18n.t("title.reports_hour_report")
            }
        },
        {
            path: "absence",
            name: "ReportsAbsence",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VAbsence"
                ),
            meta: {
                title: i18n.t("title.reports_absence")
            }
        },
        {
            path: "projects",
            name: "ReportsProjects",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VProjects"
                ),
            meta: {
                title: i18n.t("title.reports_projects")
            }
        },
        {
            path: "projects-performance",
            name: "ReportsProjectsPerformance",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VProjectsPerformance"
                ),
            meta: {
                title: i18n.t("title.reports_projects_performance")
            }
        },
        {
            path: "admin-projects-performance",
            name: "ReportsAdminProjectsPerformance",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VAdminProjectsPerformance"
                ),
            meta: {
                title: i18n.t("title.reports_admin_projects_performance")
            }
        },
        {
            path: "open-days",
            name: "ReportsOpenDays",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VOpenDays"
                ),
            meta: {
                title: i18n.t("title.open_days")
            }
        },
        {
            path: "personal-multiview",
            name: "ReportsPersonalMultiview",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VPersonalMultiview"
                ),
            meta: {
                title: i18n.t("title.personal_multiview")
            }
        },
        {
            path: "clock-project",
            name: "ReportsClockProject",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VClockProjectReport"
                ),
            meta: {
                title: i18n.t("title.personal_time_report_clock_and_project")
            }
        },
        {
            path: "my-hours",
            name: "ReportsMyReport",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VMyReport"
                ),
            meta: {
                title: i18n.t("title.my_report")
            }
        },
        {
            path: "my-hours-de",
            name: "ReportsMyReportDe",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VMyReportDe"
                ),
            meta: {
                title: i18n.t("title.my_report")
            }
        },
        {
            path: "my-clock-hours",
            name: "ReportsMyClockReport",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VMyClockReport"
                ),
            meta: {
                title: i18n.t("title.my_clock_report")
            }
        },
        {
            path: "contracts",
            name: "NewContractsReports",
            component: () =>
                import(
                    /* webpackChunkName: "reports" */ "@/views/Reports/Contracts/VContracts"
                ),
            meta: {
                title: i18n.t("title.reports")
            }
        },
        {
            path: "contracts/data/:src_group",
            name: "ContractsReportsData",
            component: () =>
                import(
                    /* webpackChunkName: "reports" */ "@/views/Reports/Contracts/VStatData"
                ),
            meta: {
                title: i18n.t("title.reports")
            },
            props: true
        },
        {
            path: "budget",
            name: "ReportsBudget",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VBudget"
                ),
            meta: {
                title: i18n.t("title.budget")
            }
        },
        {
            path: "projects-reports",
            name: "PlanningProjectsReports",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/ProjectsPlanning/VReports"
                ),
            meta: {
                title: i18n.t("title.reports"),
                hideTop: true
            }
        },
        {
            path: "utilization-factor",
            name: "UtilizationFactorReport",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Reports/VUtilFactor"
                ),
            meta: {
                title: i18n.t("title.utilization_factor_report"),
                hideTop: true
            }
        },
        {
            path: "mb-report/:reference",
            name: "MetabaseReports",
            component: () =>
                import(
                    /* webpackChunkName "reports" */ "@/views/Metabase/VMetabaseReports"
                ),
            meta: {
                title: i18n.t("title.reports")
            },
            props: true
        }
    ]
};

export default reportsMenu;
